export default "__VITE_ASSET__Bcs5JjmZ__"